import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const CheckEmailContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const CheckEmailIcon = styled(Box)(() => ({
  width: "120px",
  height: "120px",
  marginBottom: "44px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const CheckEmailTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
}));

export const CheckEmailSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "54px",
}));

export const CheckEmailQuestion = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "54px",
}));

export const CheckEmailActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "24px",
  alignItems: "center",
}));
